import React from 'react';
import { cx } from '../cx';

// D-09 §15.5 — Tag (.tag · 제거 버튼 optional)
export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  onRemove?: () => void;
  size?: 'sm' | 'md' | 'lg';
}

export function Tag({ onRemove, size = 'md', className = '', children, ...props }: TagProps) {
  return (
    <span className={cx('tag', size !== 'md' && `tag-${size}`, className)} {...props}>
      {children}
      {onRemove && (
        <button type="button" aria-label="제거" onClick={onRemove}>
          {/* 히트 영역 16 · 아이콘 8 (Figma 2269-983) — 글리프는 크기를 못 맞추어 svg 로 그린다 */}
          <svg viewBox="0 0 8 8" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" aria-hidden="true">
            <path d="M1 1 7 7M7 1 1 7" />
          </svg>
        </button>
      )}
    </span>
  );
}
